import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class fulfillmentStepsListCtrl implements IController {

  steps: any;
  selectedStep: any;
  items: any;
  fulfillmentStatus:any;
  relationsMap: any;
  onSelect: Function;
  onEdit: Function;
  onSplit: Function;
  onReset: Function;
  onCancel: Function;
  onDispatch: Function;

  /* @ngInject */
  constructor() {}

  $onInit() {}


  $onChanges(changes) {

  }

  onDispatchAllSteps($event) {
    this.onDispatch({stepIds: _.map(this.steps, 'id'), $event: $event});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsList', {
    bindings: {
      steps: '<',
      fulfillmentStatus: '<',
      selectedStep: '<',
      items: '<',
      relationsMap: '<',
      onSelect: '&',
      onEdit: '&',
      onSplit: '&',
      onReset: '&',
      onCancel: '&',
      onDispatch: '&'
    },
    template: require('./fulfillment-steps-list.html').default,
    controller: fulfillmentStepsListCtrl
  });
